import styled from 'styled-components';
import { getListStyleResetter } from './getListStyleResetter';

const OrderedList = styled.ol(getListStyleResetter());

export { OrderedList };
